<div class="container-xxl py-5">
  <!-- Header -->
  <div class="mb-5">
    <h1 class="fw-bold mb-2">{{ 'admin.title' | translate }}</h1>
    <p class="text-muted">{{ 'admin.subtitle' | translate }}</p>
  </div>

  <!-- Navigation Tabs -->
  <ul class="nav nav-tabs mb-4">
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'dashboard'" (click)="onNavigateToTab('dashboard')">
        <i class="fa-solid fa-chart-line me-2"></i>{{ 'admin.tabs.dashboard' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'users'" (click)="onNavigateToTab('users')">
        <i class="fa-solid fa-users me-2"></i>{{ 'admin.tabs.users' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'companies'" (click)="onNavigateToTab('companies')">
        <i class="fa-solid fa-building me-2"></i>{{ 'admin.tabs.companies' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'places'" (click)="onNavigateToTab('places')">
        <i class="fa-solid fa-store me-2"></i>{{ 'admin.tabs.places' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'applications'" (click)="onNavigateToTab('applications')">
        <i class="fa-solid fa-file-lines me-2"></i>{{ 'admin.tabs.applications' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'recommendations'" (click)="onNavigateToTab('recommendations')">
        <i class="fa-solid fa-star me-2"></i>{{ 'admin.tabs.recommendations' | translate }}
      </a>
    </li>
  </ul>

  <!-- Tab Content -->
  @if (selectedTab === 'dashboard') {
    <app-admin-dashboard></app-admin-dashboard>
  }

  @if (selectedTab === 'users') {
    <app-admin-users></app-admin-users>
  }

  @if (selectedTab === 'companies') {
    <app-admin-companies></app-admin-companies>
  }

  @if (selectedTab === 'places') {
    <app-admin-places></app-admin-places>
  }

  @if (selectedTab === 'applications') {
    <app-admin-applications></app-admin-applications>
  }

  @if (selectedTab === 'recommendations') {
    <app-admin-recommendations></app-admin-recommendations>
  }
</div>
